<div class="d-flex justify-content-end mb-3">
  <button class="btn btn-sm btn-secondary" type="button" (click)="refresh()" [disabled]="isLoading">
    <i class="fa fa-refresh"></i> Refresh
  </button>
</div>

@if (isLoading) {
  <div class="card">
    <div class="card-body text-center text-muted py-4">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>
  </div>
} @else if (isLoaded) {
  <div class="card">
    <div class="card-header">
      <i class="fa fa-line-chart"></i> CCU - Last 7 days
    </div>
    <div class="card-body">
      @if (ccuChartData.labels?.length) {
        <div class="row g-2 mb-3">
          <div class="col-6 col-md-3">
            <div class="card bg-primary text-white text-center mb-0">
              <div class="card-body py-1 px-2">
                <div class="text-uppercase" style="font-size: 0.7rem;">Current</div>
                <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ currentPlayers }}</div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="card bg-success text-white text-center mb-0">
              <div class="card-body py-1 px-2">
                <div class="text-uppercase" style="font-size: 0.7rem;">Average</div>
                <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ averagePlayers }}</div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="card bg-info text-white text-center mb-0">
              <div class="card-body py-1 px-2">
                <div class="text-uppercase" style="font-size: 0.7rem;">Max</div>
                <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ maxPlayers }}</div>
              </div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="card bg-warning text-white text-center mb-0">
              <div class="card-body py-1 px-2">
                <div class="text-uppercase" style="font-size: 0.7rem;">Min</div>
                <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ minPlayers }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative; height: 350px; width: 100%; overflow: hidden;">
          <c-chart type="line" [data]="ccuChartData" [options]="ccuChartOptions" style="position: absolute; inset: 0;"></c-chart>
        </div>
      } @else {
        <div class="text-center text-muted py-4">No data available.</div>
      }
    </div>
  </div>

  <div class="card mt-4">
    <div class="card-header">
      <i class="fa fa-money"></i> Credits - Last 7 days
    </div>
    <div class="card-body">
      @if (creditChartData.labels?.length) {
        <div class="mb-2">
          <h6 class="text-muted text-uppercase small mb-2">Gains</h6>
          <div class="row g-2">
            <div class="col-4">
              <div class="card bg-success text-white text-center mb-0">
                <div class="card-body py-1 px-2">
                  <div class="text-uppercase" style="font-size: 0.7rem;">Average</div>
                  <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ averageGain }}</div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card bg-info text-white text-center mb-0">
                <div class="card-body py-1 px-2">
                  <div class="text-uppercase" style="font-size: 0.7rem;">Max</div>
                  <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ maxGain }}</div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card bg-warning text-white text-center mb-0">
                <div class="card-body py-1 px-2">
                  <div class="text-uppercase" style="font-size: 0.7rem;">Min</div>
                  <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ minGain }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-2">
          <h6 class="text-muted text-uppercase small mb-2">Spent</h6>
          <div class="row g-2">
            <div class="col-4">
              <div class="card bg-success text-white text-center mb-0">
                <div class="card-body py-1 px-2">
                  <div class="text-uppercase" style="font-size: 0.7rem;">Average</div>
                  <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ averageSpent }}</div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card bg-info text-white text-center mb-0">
                <div class="card-body py-1 px-2">
                  <div class="text-uppercase" style="font-size: 0.7rem;">Max</div>
                  <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ maxSpent }}</div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card bg-warning text-white text-center mb-0">
                <div class="card-body py-1 px-2">
                  <div class="text-uppercase" style="font-size: 0.7rem;">Min</div>
                  <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ minSpent }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <h6 class="text-muted text-uppercase small mb-2">Balance</h6>
          <div class="row g-2">
            <div class="col-4">
              <div class="card bg-primary text-white text-center mb-0">
                <div class="card-body py-1 px-2">
                  <div class="text-uppercase" style="font-size: 0.7rem;">Average</div>
                  <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ averageBalance }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative; height: 350px; width: 100%; overflow: hidden;">
          <c-chart type="line" [data]="creditChartData" [options]="creditChartOptions" style="position: absolute; inset: 0;"></c-chart>
        </div>
        <h6 class="text-muted text-uppercase small mt-4 mb-2">Rake (%)</h6>
        <div style="position: relative; height: 250px; width: 100%; overflow: hidden;">
          <c-chart type="line" [data]="rakeChartData" [options]="rakeChartOptions" style="position: absolute; inset: 0;"></c-chart>
        </div>
      } @else {
        <div class="text-center text-muted py-4">No data available.</div>
      }
    </div>
  </div>
}
